export const SunMark = ({ size = 40, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="Indigenous Security Services sun logo"
    role="img"
  >
    <circle cx="32" cy="32" r="30" fill="#0F172A" stroke="#F59E0B" strokeWidth="1.5" opacity="0.35" />
    {Array.from({ length: 12 }).map((_, i) => {
      const a = (i * 30 * Math.PI) / 180;
      const long = i % 2 === 0;
      const r1 = 19;
      const r2 = long ? 29 : 24;
      return (
        <line
          key={i}
          x1={32 + r1 * Math.cos(a)}
          y1={32 + r1 * Math.sin(a)}
          x2={32 + r2 * Math.cos(a)}
          y2={32 + r2 * Math.sin(a)}
          stroke={long ? "#F59E0B" : "#D97706"}
          strokeWidth={long ? 2.6 : 1.8}
          strokeLinecap="round"
        />
      );
    })}
    <circle cx="32" cy="32" r="15" fill="url(#sunGrad)" />
    <circle cx="32" cy="32" r="15" stroke="#FBBF24" strokeWidth="1.2" />
    <path d="M 24 35 Q 32 27 40 35" stroke="#7C2D12" strokeWidth="2.2" fill="none" strokeLinecap="round" />
    <circle cx="27" cy="30" r="1.6" fill="#7C2D12" />
    <circle cx="37" cy="30" r="1.6" fill="#7C2D12" />
    <defs>
      <radialGradient id="sunGrad" cx="0.4" cy="0.35" r="0.9">
        <stop offset="0%" stopColor="#FBBF24" />
        <stop offset="60%" stopColor="#F59E0B" />
        <stop offset="100%" stopColor="#D97706" />
      </radialGradient>
    </defs>
  </svg>
);
